import { render, staticRenderFns } from "./WallkitPricing.vue?vue&type=template&id=78e6d187"
import script from "./WallkitPricing.vue?vue&type=script&lang=js"
export * from "./WallkitPricing.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports